import { CardID, ColumnID, RowID } from "./constants";
export default function kanbanUpdates(api, resolver) {
    function card(obj) {
        if ("id" in obj)
            obj.id = resolver(obj.id, CardID);
        if ("column" in obj)
            obj.column = resolver(obj.column, ColumnID);
        if ("row" in obj)
            obj.row = resolver(obj.row, RowID);
        return obj;
    }
    function row(obj) {
        if ("id" in obj)
            obj.id = resolver(obj.id, RowID);
        return obj;
    }
    function column(obj) {
        if ("id" in obj)
            obj.id = resolver(obj.id, ColumnID);
        return obj;
    }
    function cardsUpdate(obj) {
        const c = card(obj.card);
        c.start_date = c.start_date ? new Date(c.start_date) : null;
        c.end_date = c.end_date ? new Date(c.end_date) : null;
        switch (obj.type) {
            case "add-card":
                api.exec(obj.type, {
                    skipProvider: true,
                    card: c,
                    select: false,
                });
                break;
            case "update-card":
                api.exec("update-card", {
                    skipProvider: true,
                    id: c.id,
                    card: c,
                });
                break;
            case "delete-card":
                api.exec("delete-card", {
                    skipProvider: true,
                    id: c.id,
                });
                break;
            case "move-card": {
                api.exec("move-card", {
                    skipProvider: true,
                    id: c.id,
                    rowId: c.row,
                    columnId: c.column,
                    before: resolver(obj.before, CardID),
                });
                break;
            }
        }
    }
    function columnsUpdate(obj) {
        const c = column(obj.column);
        switch (obj.type) {
            case "add-column":
                api.exec("add-column", {
                    skipProvider: true,
                    column: c,
                });
                break;
            case "delete-column":
                api.exec("delete-column", {
                    skipProvider: true,
                    id: c.id,
                });
                break;
            case "update-column":
                api.exec("update-column", {
                    skipProvider: true,
                    id: c.id,
                    column: c,
                });
                break;
            case "move-column":
                api.exec("move-column", {
                    skipProvider: true,
                    id: c.id,
                    before: resolver(obj.before, ColumnID),
                });
        }
    }
    function rowsUpdate(obj) {
        const r = row(obj.row);
        switch (obj.type) {
            case "add-row":
                api.exec("add-row", {
                    skipProvider: true,
                    row: r,
                });
                break;
            case "delete-row":
                api.exec("delete-row", {
                    skipProvider: true,
                    id: r.id,
                });
                break;
            case "update-row":
                api.exec("update-row", {
                    skipProvider: true,
                    id: r.id,
                    row: r,
                });
                break;
            case "move-row":
                api.exec("move-row", {
                    skipProvider: true,
                    id: r.id,
                    before: resolver(obj.before, RowID),
                });
        }
    }
    return {
        cards: cardsUpdate,
        columns: columnsUpdate,
        rows: rowsUpdate,
    };
}
//# sourceMappingURL=KanbanUpdates.js.map